import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MultipleSelectItemComponent } from '../../multiple-select-item/multiple-select-item.component';
import { DataService } from 'src/app/services/data.service';
import { APIService } from 'src/app/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-rpt-inv-multi-mtl-requirement',
  templateUrl: './rpt-inv-multi-mtl-requirement.component.html',
  styleUrls: ['./rpt-inv-multi-mtl-requirement.component.scss']
})
export class RptInvMultiMtlRequirementComponent implements OnInit {

  //Table sort and column
  displayedColumns: string[] = ['Material', 'requiredQty', 'pndgSOQty', 'planQty', 'totalNeedQty', 'stockQty', 'poQty', 'pndgPrdJobQty', 'shortFallQty', 'Unit'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  modalReference: any;
  selectedItems: any[] = [];
  products: any[] = [];
  BOMData: any = [];
  prductData: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  productID: number = 0;
  materialRequirementList: any = [];
  exportToExcel: any = [];
  
  constructor(private modalService: NgbModal, private router: Router, private SpinnerService: NgxSpinnerService,
    private dataSer: DataService, private apiService: APIService) { 
    this.dataSer.items.subscribe((value :any) => {
      this.selectedItems = value;
      this.dataSource.data = [];
    });
  }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  }

  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { 
      windowClass: "itemSelectionModalClass", 
      backdrop: 'static', 
      keyboard: false 
    });
    
    // Configure the modal component
    this.modalReference.componentInstance.typeID = 0; // Transaction Type
    this.modalReference.componentInstance.it = this.selectedItems.map((a: any) => a.ItemID);
    this.modalReference.componentInstance.st = 0; // Store ID
    this.modalReference.componentInstance.rm = 0; // Show Raw-Material
    this.modalReference.componentInstance.ft = 0; // From Transaction Page
    this.modalReference.componentInstance.isProuction = 1; // Show Internal Manufacture
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  }

  updateQuantity(item: any) {
    if (item.ReqdQty) {
      item.ReqdQty = Number(item.ReqdQty).toFixed(item.SKUPrecision);
    }
  }

  numbersOnly(item: any) {
    if (isNaN(item.ReqdQty)) {
      item.ReqdQty = '';
    }
  }

  removeItem(index: number) {
    this.selectedItems.splice(index, 1);
  }

  //Get Data - Call API
  calculateRequirement() {
    // Validate quantities
    const invalidItems = this.selectedItems.filter(item => 
      !item.ReqdQty || isNaN(item.ReqdQty) || Number(item.ReqdQty) <= 0
    );

    if (invalidItems.length > 0) {
      // Show error message
      this.apiService.successAlert('Please enter valid quantities for all items');
      return;
    }

    let finalProductData: any = [];
    this.selectedItems.forEach(function(value:any){
      finalProductData.push({
        IID: value.ItemID,
        Qty: value.ReqdQty,
        Unit: value.SKU
      });
    });

    this.materialRequirementList = [];
    this.getMaterialsData(finalProductData);
  }

  expandItem(element: any) {
    if (!element.BOM || element.BOM.length === 0) {
      return;
    }
  
    // Remove the expanded item right away
    const expandedItemIndex = this.materialRequirementList.findIndex(
      (item: any) => item.MID === element.MID
    );
    if (expandedItemIndex >= 0) {
      this.materialRequirementList.splice(expandedItemIndex, 1);
    }
  
    // Track which BOM items are already in the list
    const existingItems = new Map<number, number>(); // ItemID -> index in materialRequirementList
    const newBomItems: any[] = [];
    
    // First pass: Identify existing items and new items
    element.BOM.forEach((bomItem: any) => {
      const existingIndex = this.materialRequirementList.findIndex(
        (item: any) => item.MID === bomItem.IID
      );
      
      if (existingIndex >= 0) {
        existingItems.set(bomItem.IID, existingIndex);
      } else {
        newBomItems.push(bomItem);
      }
    });
  
    // If we found existing items, update their quantities
    if (existingItems.size > 0) {
      existingItems.forEach((index, itemId) => {
        const bomItem = element.BOM.find((item: any) => item.IID === itemId);
        if (bomItem) {
          // Calculate additional quantity needed based on parent item's total needed quantity
          const additionalQty = bomItem.Qty * element.RequiredQty;
          
          // Update existing item's quantities
          this.materialRequirementList[index].RequiredQty += additionalQty;
          this.materialRequirementList[index].requiredQty = this.materialRequirementList[index].RequiredQty;

          this.materialRequirementList[index].TotalNeedQty = Number(Number(this.materialRequirementList[index].RequiredQty) + Number(this.materialRequirementList[index].PndgSOQty) + Number(this.materialRequirementList[index].PlanQty));
          this.materialRequirementList[index].totalNeedQty = this.materialRequirementList[index].TotalNeedQty.toFixed(this.materialRequirementList[index].Prcsn);
          this.materialRequirementList[index].ShortFallQty = Number(this.materialRequirementList[index].TotalNeedQty - this.materialRequirementList[index].StockQty - this.materialRequirementList[index].POQty - this.materialRequirementList[index].PndgPrdJobQty);
          this.materialRequirementList[index].shortFallQty = this.materialRequirementList[index].ShortFallQty <= 0 ? '-' : this.materialRequirementList[index].ShortFallQty.toFixed(this.materialRequirementList[index].Prcsn);
        }
      });
  
      // Update the table after modifying existing items
      this.dataSource.data = this.materialRequirementList;
    }
  
    // If we have new items, call the API to get their details
    if (newBomItems.length > 0) {
      let finalProductData = [{
        IID: element.MID,
        Qty: element.RequiredQty,
        Unit: element.Unit
      }];
  
      this.getMaterialsData(finalProductData);
    }
  }

  getMaterialsData(products: any) {

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [
      {
        'ProductsJSON': JSON.stringify(products)
      }
    ];

    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getMultiMaterialRequirement',
        moduleID: 12,
        data: JSON.stringify(data),
      },
    ];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }

  //Success Response - Success handler
  successResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var responseData = JSON.parse(res.updatePackage);
        if (responseData.Table[0].ErrCode != '-1') {
          alert(responseData.Table[0].ErrMsg);
        } else {
          if (responseData.Table[0].ErrCode == -1) {

            // Filter out items that are already in the list
            const newItems = responseData.Table1.filter((item: any) => !this.materialRequirementList.some((existing : any) => existing.MID === item.MID)).map((item: any) => ({
              ...item,
              BOM: item.BOM ? JSON.parse(item.BOM) : []
            }));

            // Add filtered new items to the list
            this.materialRequirementList.push(...newItems);

            this.materialRequirementList.forEach((material: any) => {

              //process material data for Precision
              material.requiredQty = material.RequiredQty.toFixed(material.Prcsn);
              material.stockQty = material.StockQty.toFixed(material.Prcsn);
              material.poQty = material.POQty.toFixed(material.Prcsn);
              material.pndgSOQty = material.PndgSOQty.toFixed(material.Prcsn);
              material.pndgPrdJobQty = material.PndgPrdJobQty.toFixed(material.Prcsn);
              material.planQty = material.PlanQty.toFixed(material.Prcsn);

              material.TotalNeedQty = Number(Number(material.RequiredQty) + Number(material.PndgSOQty) + Number(material.PlanQty));
              material.totalNeedQty = material.TotalNeedQty.toFixed(material.Prcsn);
              material.ShortFallQty = Number(material.TotalNeedQty - material.StockQty - material.POQty - material.PndgPrdJobQty);
              material.shortFallQty = material.ShortFallQty <= 0 ? '-' : material.ShortFallQty.toFixed(material.Prcsn);
          });

            this.dataSource.data = this.materialRequirementList;
            this.exportToExcel = this.materialRequirementList;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.matSort;
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  changeTarget() {
    this.dataSource.data = [];
  }

  //search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Export To Excel
  exportToExcelActivities() {
    var html = "";
    
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Material Requirement</th>"
    html += "</table></tr>";
    
    html += "<table><tr></table></tr>";
    
    // Add Selected Items Section
    html += "<table>";
    html += "<tr><th style='text-align: left; background-color: #f0f0f0;' colspan='3'>Selected Items</th></tr>";
    html += "<tr>";
    html += "<th style='text-align: left;'>Item</th>";
    html += "<th style='text-align: left;'>Qty</th>";
    html += "<th style='text-align: left;'>Unit</th>";
    html += "</tr>";
    
    // Add selected items data
    this.selectedItems.forEach((item: any) => {
        html += "<tr>";
        html += "<td style='text-align: left;'>" + item.ItemName + "</td>";
        html += "<td style='text-align: left;'>" + (item.ReqdQty || '-') + "</td>";
        html += "<td style='text-align: left;'>" + item.SKU + "</td>";
        html += "</tr>";
    });
    
    html += "</table>";
    
    // Add spacing between tables
    html += "<table><tr><td>&nbsp;</td></tr></table>";
    
    // Material Requirements Section
    html += "<table>";
    html += "<tr><th style='text-align: left; background-color: #f0f0f0;' colspan='10'>Material Requirements</th></tr>";
    html += "<tr>";
    
    // Header for material requirements
    var strHeader = "";
    strHeader += "<th style='text-align: left;'>Material</th>";
    strHeader += "<th style='text-align: left;'>Required Qty</th>";
    strHeader += "<th style='text-align: left;'>Orders</th>";
    strHeader += "<th style='text-align: left;'>Planned Use</th>";
    strHeader += "<th style='text-align: left;'>Total Need</th>";
    strHeader += "<th style='text-align: left;'>Stock</th>";
    strHeader += "<th style='text-align: left;'>PO</th>";
    strHeader += "<th style='text-align: left;'>WIP</th>";
    strHeader += "<th style='text-align: left;'>Shortfall</th>";
    strHeader += "<th style='text-align: left;'>Unit</th>";
    strHeader += "</tr>";
    html += strHeader;
    
    // Body for material requirements
    var body = "";
    this.exportToExcel.forEach((item: any, key: any) => {
        body += "<tr>";
        body += "<td style='text-align: left;'>" + item.Material + "</td>";
        body += "<td style='text-align: left;'>" + (item.requiredQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.pndgSOQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.planQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.totalNeedQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.stockQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.poQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.pndgPrdJobQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.shortFallQty || '-') + "</td>";
        body += "<td style='text-align: left;'>" + item.Unit + "</td>";
        body += "</tr>";
    });
    
    html += body;
    html += "</table>";
    
    this.tableToExcel(html, 'Sheet1', 'Material Requirement');
  }

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  backBtn() {
    this.router.navigate(['/inventory']);
  }

  refresh() {
    window.location.reload();
  }

}